import { gql } from '@apollo/client';
import { UPLOAD_FIELDS } from '../fragments';

const TICKET_SUMMARY = `
  id
  supportId
  title
  description
  replyCount
  isClosed
  createdAt
  user {
    id
    firstName
    lastName
    profileStudent {
      profileImg
    }
  }
`;

/** Every ticket — administrators only. `isClosed` defaults to open. */
export const GET_SUPPORTS = gql`
  query getSupports($isClosed: Boolean) {
    supports(isClosed: $isClosed) {
      ${TICKET_SUMMARY}
    }
  }
`;

/** The caller's own tickets. Replaces `userSupports(where:)`. */
export const GET_USER_SUPPORTS = gql`
  query getMySupports {
    mySupports {
      ${TICKET_SUMMARY}
    }
  }
`;

/**
 * A ticket and its replies. Replies are a subcollection, so they come back
 * alongside rather than nested under the ticket.
 */
export const GET_SUPPORT_WITH_REPLIES = gql`
  query getSupportWithReplies($id: String!) {
    support(id: $id) {
      id
      supportId
      title
      description
      isClosed
      createdAt
      user {
        id
        firstName
        lastName
        profileStudent {
          profileImg
        }
      }
      uploads {
        ...UploadFields
      }
    }
    supportReplies(supportId: $id) {
      id
      message
      viewed
      createdAt
      user {
        id
        firstName
        lastName
        profileStudent {
          profileImg
        }
        profileTeacher {
          profileImg
        }
      }
    }
  }
  ${UPLOAD_FIELDS}
`;

export const GET_SUPPORT_REPLY = gql`
  query getSupportReplies($supportId: String!) {
    supportReplies(supportId: $supportId) {
      id
      supportId
      message
      viewed
      createdAt
      user {
        id
        firstName
        lastName
        profileStudent {
          profileImg
        }
        profileTeacher {
          profileImg
        }
      }
    }
  }
`;

/**
 * `recipients` is readable by the sender and administrators only — a
 * recipient may read the message, but the distribution list names everyone
 * else who received it.
 */
export const GET_MESSAGING = gql`
  query getMessaging($id: String!) {
    messaging(id: $id) {
      id
      type
      title
      body
      recipientCount
      createdAt
      sender {
        id
        firstName
        lastName
      }
      recipients {
        id
        firstName
        lastName
        accountType
        email
      }
    }
  }
`;

/**
 * The messaging screens are an outbox, so this is what the caller has sent.
 * `messages` — what was addressed to them — is the other direction.
 */
export const GET_MESSAGES = gql`
  query getSentMessages($type: MessageType) {
    sentMessages(type: $type) {
      id
      type
      title
      body
      recipientCount
      createdAt
      sender {
        id
        firstName
        lastName
      }
    }
  }
`;
